import { put, call } from 'redux-saga/effects';
import { clientQuery } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';

// Actions
import {
  reportsMainGenerateReportProgress
} from 'Redux/actions';

import {
  getTimeZone,
  handleAsyncReport,
  getCategoryFilter,
  generateReportInstance,
  baseReportConditions,
  isJsonFormat
} from 'Modules/reports/views/main/components/reportsTab/helper';

function* getLandmarkCrewReport(report, page, rowsPerPage, sortField, sortOrder) {
  const { filterType, filterArray, startRange, endRange, otherFilters, unitsSelected, filterEntity } = report.filters;
  let minutes = otherFilters.minute ? otherFilters.minute * 60 : 0;
  const { timeZone, sendByEmail, emailsTo, name, timeframeName, categoryName, delayed, dataResultPath } = report;
  const baseConditionsQuery = baseReportConditions({ report, name, dataResultPath, timeZone, delayed, unitsSelected, timeframeName , filterType, filterArray, categoryName, startRange, endRange})
  let payload = {
    conditions: {
      ...baseConditionsQuery,
      sortField: {
        field: sortField || "deviceId",
        order: sortOrder === 'desc' ? 'DESC' : 'ASC'
      },
      integerRanges: {
        fields: [
          "idle"
        ],
        GTE: minutes,
        LTE: 0
      }
    },
    offset: page,
    limit: rowsPerPage
  }
  if (report.export) {
     payload = {
      conditions: {
        ...payload.conditions,
        exportOptions: {
          sendByEmail,
          emailsTo,
          culture: report.lang,
          timeZone: getTimeZone(timeZone),
          format: {
            fileFormat: report?.exportType  || "json",
            formatOptions: "{}",
            durationFormat: report?.durationFormat
          },
          folderName: "px-customer-reports",
          filePrefixName: "landmarkCrewReport",
          columns: [
            {
              "column": "idName",
              "header": getCategoryFilter(filterType) === "deviceId" ? "Unit" : "Driver"
            },
            {
                "column": "date",
                "header": "Time & Date"
            },
            {
                "column": "landmarkName",
                "header": "Landmark"
            },
            {
                "column": "idLabel",
                "header": getCategoryFilter(filterType) === "deviceId" ? "Driver" : "Unit"
            },
            {
                "column": "crewMemberName",
                "header": "Crew Member"
            },
            {
                "column": "crewMemberDuration",
                "header": "Crew Member Total Time In Landmark"
            },
            {
              "column": "vehicleDuration",
              "header": (getCategoryFilter(filterType) === "deviceId" ? "Driver" : "Unit") + " Total Time In Landmark"
            }
          ]
        }
      },
      limit: isJsonFormat(report?.exportType, dataResultPath) ? rowsPerPage : 5000,
      offset: isJsonFormat(report?.exportType, dataResultPath) ? page : 1
    }
  }
  try {
    let data = yield call(
      clientQuery,
      `query($conditions: ReportConditionsInput, $limit: Int, $offset: Int) {
        Report: getLandmarkCrewReport(conditions: $conditions, limit: $limit, offset: $offset) {
          ${generateReportInstance(report.export, dataResultPath, report.exportFromTable) ?  

            `reportInstanceId`
          :`
            total
            limit
            offset
            category
            items {
              id
              idLabel
              dates
              noData
            }
          `}
        }
      }`,
      payload,
      endpoints.GRAPHQL_PX_REPORTING,
    );

    yield handleAsyncReport(report, data)
  } catch (exc) {
    report.loading = false
    yield put(reportsMainGenerateReportProgress(report))
  }
}


export default getLandmarkCrewReport;
